import { render, staticRenderFns } from "./modalDocumentosNF.vue?vue&type=template&id=45de4246&"
import script from "./modalDocumentosNF.vue?vue&type=script&lang=js&"
export * from "./modalDocumentosNF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports